import { useState, useEffect } from 'react';

var MEDIA_QUERY = '(prefers-color-scheme: dark)';
var MODE_DARK = 'dark';
var MODE_LIGHT = 'light';

var getMatchMedia = function () {
    return window.matchMedia && window.matchMedia(MEDIA_QUERY);
};
var getColorMode = function (matchQueryList) {
    return matchQueryList && matchQueryList.matches ? MODE_DARK : MODE_LIGHT;
};
var getBindingEvents = function (matchQueryList, handler) {
    if (matchQueryList.addEventListener) {
        return {
            bindEvent: function () { return matchQueryList.addEventListener('change', handler); },
            unbindEvent: function () {
                return matchQueryList.removeEventListener('change', handler);
            },
        };
    }
    return {
        bindEvent: function () { return matchQueryList.addListener(handler); },
        unbindEvent: function () { return matchQueryList.removeListener(handler); },
    };
};

var useColorMode = function () {
    var _a = useState(getColorMode(getMatchMedia())), colorMode = _a[0], setColorMode = _a[1];
    var handleChange = function () {
        window.requestAnimationFrame(function () {
            setColorMode(getColorMode(getMatchMedia()));
        });
    };
    useEffect(function () {
        var _a = getBindingEvents(getMatchMedia(), handleChange), bindEvent = _a.bindEvent, unbindEvent = _a.unbindEvent;
        bindEvent();
        return unbindEvent;
    }, []);
    return colorMode;
};

export { useColorMode };
//# sourceMappingURL=index.es.js.map
